export default "__VITE_PUBLIC_ASSET__fb19d7f7__"